module.exports = __webpack_public_path__ + "img/con1-tittle.56d5f34a.png";